import axios from '@/lib/AxApi';

export default
{
    selectRow(params, cb)
    {
        axios.get('/Modules/selectRow',
            {
                params,
            })
            .then((response) =>
            {
                cb(response.data);
            })
            .catch((e) =>
            {
                // TODO
            });
    },
    getModuleHistory(params, cb)
    {
        axios.get('/Modules/getModuleHistory', { params })
            .then((response) =>
            {
                cb(response.data);
            })
            .catch(() =>
            {
                cb({ error: true, notice: 'Network error' });
            });
    },
    getMdiIcons(params, cb)
    {
        axios.get('/Modules/getMdiIcons', { params })
            .then((response) =>
            {
                cb(response.data);
            })
            .catch(() =>
            {
                cb({ error: true, notice: 'Network error' });
            });
    },
    getPossibleIcons(params, cb)
    {
        axios.get('/Modules/getPossibleIcons',
            {
                params,
            })
            .then((response) =>
            {
                cb(response.data);
            })
            .catch((e) =>
            {
                // TODO
            });
    },
    save(params, cb)
    {
        axios.post('/Modules/updateRow', params)
            .then((response) =>
            {
                cb(response.data);
            })
            .catch((e) =>
            {
                // TODO
            });
    },
    saveModuleUsers(params, cb)
    {
        axios.post('/Modules/updateUsers', params)
            .then((response) =>
            {
                cb(response.data);
            })
            .catch((e) =>
            {
                // TODO
            });
    },
    activateModule(params, cb)
    {
        axios.post('/Modules/activateDevice', params)
            .then((response) =>
            {
                cb(response.data);
            })
            .catch((e) =>
            {
                // TODO
            });
    },
    async setThermostat(params)
    {
        try
        {
            const response = await axios.post('/Modules/setThermostat', params);
            return response.data;
        }
        catch (error)
        {
            // TODO
        }
    },
    async setDimmer(params)
    {
        try
        {
            const response = await axios.post('/Modules/setDimmer', params);
            return response.data;
        }
        catch (error)
        {
            // TODO
        }
    },
    // the module ids in the order the dashboard should show them
    saveOrder(params, cb)
    {
        axios.post('/Modules/saveOrder', params)
            .then((response) =>
            {
                cb(response.data);
            })
            .catch((e) =>
            {
                cb({ error: true, notice: (e && e.message) ? e.message : 'Network error' });
            });
    },
    activateSecModule(params, cb)
    {
        axios.post('/Modules/activateSecDevice', params)
            .then((response) =>
            {
                cb(response.data);
            })
            .catch((e) =>
            {
                // TODO
            });
    },
    setRoomThermostat(params, cb)
    {
        axios.post('/Modules/setRoomThermostat', params)
            .then((response) =>
            {
                cb(response.data);
            })
            .catch(() =>
            {
                cb({ error: true, notice: 'Network error' });
            });
    },
    stopModule(params, cb)
    {
        axios.post('/Modules/stopDevice', params)
            .then((response) =>
            {
                cb(response.data);
            })
            .catch(() =>
            {
                cb({ error: true, notice: 'Network error' });
            });
    },
    getTemp(params, cb)
    {
        axios.post('/Modules/getTemp', params)
            .then((response) =>
            {
                cb(response.data);
            })
            .catch((e) =>
            {
                // TODO
            });
    },
    reset(params, cb)
    {
        axios.post('/Modules/reset', params)
            .then((response) =>
            {
                cb(response.data);
            })
            .catch((e) =>
            {
                // TODO
            });
    },
    deleteRow(params, cb)
    {
        axios.post('/Modules/deleteRow', params)
            .then((response) =>
            {
                cb(response.data);
            })
            .catch((e) =>
            {
                // TODO
            });
    },
};
